module.exports = __webpack_public_path__ + "img/IQ.a682a7c8.png";